import { render, staticRenderFns } from "./Timeago.vue?vue&type=template&id=3f9cf87a"
import script from "./Timeago.vue?vue&type=script&lang=js"
export * from "./Timeago.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports